import React, { useEffect, useState } from 'react'
import "./popupXLarge.css"
import "./popup.css"
import "./popupMedium.css" 
import "./popupSmall.css"
import "./popupXSmall.css"
import {RxCross1} from 'react-icons/rx';
import {HiOutlinePlus, HiOutlineMinus} from "react-icons/hi"

const PopupProject = (props) => {

  const [isPopupProject, setPopupProject] = useState(props?.popupProject);
  const [selected, setSelected] = useState(null);
  const [detailsIndex, setDetailsIndex ] = useState(0)

  //OPEN AND CLOSE POPUP, RESET IMAGE
  useEffect(() => {
    setPopupProject(props?.popupProject)
    if (isPopupProject === false) {
      setDetailsIndex(0)
    }
  }, [props?.popupProject, isPopupProject]);

  // CLOSE ACCORDION AND CLOSE POPUP 
  function closePopup() {
    setSelected(null);
    setTimeout(() => {
      props.setPopupProject(false)
    });
  }

  // OPEN THE SELECTED ACCORDION TAB AND SHOW THE AFFILIATED IMAGE
  const toggle = (index) => {
    if (selected === index) {
      return setSelected(null)
    }
    setSelected(index)
    setTimeout(() => {
      setDetailsIndex(index)
    });
  }

  

  return (
    <div  className={`${isPopupProject ? "popup-wrapper" : "hidden"}`}  >
        <div  className='popup' onClick={() => closePopup()}></div>
        <div className='popup-inner project-flex'>
            <div className='popup-left'>
              <img src={props?.category?.details[detailsIndex]?.image}  loading="lazy" alt='project first visual'/>
            </div>

            <div className='popup-right'>
                <div className='popup-right-intro'>
                  <h1 className='popup-title'>{props?.category?.name}</h1>
                  <button className='close-btn' >
                    <RxCross1 onClick={() => closePopup()} />
                  </button>
                </div>

                
                <div className='accordions' >
                { props?.category?.details && props?.category?.details?.map((item, index)=> {
                    return (
                    <div className='accordion' key={index}>
                      <div className='accordion-intro' onClick={() => toggle(index)}>
                        <div className='accordion-intro-left'>
                          <h4 className='accordion-title'>{item?.title}</h4>
                          <p>{item?.subtitle}</p>
                        </div>
                        <div className='accordion-intro-right'>
                          {selected === index ? <HiOutlineMinus/>  : <HiOutlinePlus /> }
                          
                        </div>
                      </div>
                      <div className={selected === index ? 'accordion-content appear' : 'accordion-content'}>
                        <p>
                        {item?.description?.map((desc, index) =>{
                          return (
                            <div className='accordion-content-map' key={index}>
                              {desc}
                            </div>
                          )
                        })}
                        </p>
                      </div>
                    </div>
                )})}
              </div>


              <div className='accordion-footer-wrapper'>
                <div className='accordion-footer'>
                    {props?.category?.links && props?.category?.links?.map((item, index) => {
                      return (
                        <div className='project-site' key={index}>
                          <a href={item?.link}  target="_blank" rel="noreferrer" className="project__logo__link">
                            <div className='logo link-logo'>
                              {item?.logo}
                            </div>
                            <div className='footer-info'>
                              <h4>{item?.title}</h4>
                            </div>
                          </a>
                        </div>
                      )
                    })}
                  </div>
              </div>


            </div>
        </div>
    </div>
  ) ;
}

export default PopupProject